export default "__VITE_ASSET__DRXFuY2N__"